var React = require('react');

function Navigation (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M4.5,38.365,79.16,3,43.795,77.66,35.936,46.224Z","transform":"translate(-2.5 -1)","fill":"none","stroke":"#38a9bf","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"4"}));
}

Navigation.defaultProps = {"width":"78.66","height":"78.66","viewBox":"0 0 78.66 78.66"};

module.exports = Navigation;

Navigation.default = Navigation;
